/**
 * Depending on the customer's configuration, the login process has different steps.
 * - A customer that has SSO enabled from the start will have the following flow:
 *   SSO -> *external login* -> *done*
 * - A customer that enabled SSO after some users have already signed up will have the the following flow:
 *   EMAIL -> PASSWORD -> (TWO_FA) -> ADD_SSO -> *external login* -> *done*
 *         -> *external login* -> *done*
 * - A customer that doesn't have SSO enabled will have the following flows:
 *   EMAIL_AND_PASSWORD -> (TWO_FA) -> *done*
 */

import { type SsoConfig } from "../api/v2/useSsoConfig";

export enum AuthStep {
  EMAIL = "email",
  PASSWORD = "password",
  EMAIL_AND_PASSWORD = "email_and_password",
  SSO = "sso",
  TWO_FA = "two_fa",
  ADD_SSO = "add_sso",
}

export const getFirstStep = (ssoConfig: SsoConfig) => {
  if (ssoConfig.ssoOnly) {
    return AuthStep.SSO;
  } else if (ssoConfig.ssoEnabled) {
    return AuthStep.EMAIL;
  } else {
    return AuthStep.EMAIL_AND_PASSWORD;
  }
};
